import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FormatDatasetV2 } from './dataset.v2';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.jsonDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.ModelName_JsonDataset),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.ModelName_JsonDataset)
    ]
})
export class JsonDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly ENCODING_NAME?: IAttribute;
    public static readonly COMPRESSION_CODEC?: IAttribute;
    public static readonly COMPRESSION_LEVEL?: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENCODING_NAME',
        display: shellStringResources.ModelName_Encoding
    })
    public encodingName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        display: shellStringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_LEVEL',
        display: shellStringResources.ModelName_CompressionLabel
    })
    public compressionLevel?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
